export const MODAL_WIDTH = 800;

export const MODAL_Z_INDEX = 1200;

export const PADDING_MAIN_SCREEN = "40px 107px";

export const PADDING_STATUS_SCREEN = "40px 33px";

export const PADDING_STATUS_SCREEN_WITH_PAGINATION = "40px 33px 0";

export const INVITATIONS_PER_PAGE = 7;

export const EVENTS_CATEGORY = "Referrals";
